
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"98","height":"87","viewBox":"0 0 98 87","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.373 57.934l.664-.779 6.605 1.016-.05.059-4.33-3.688.556-.653 5.26 4.48-.621.728-6.826-1.045.086-.1 4.472 3.808-.556.653-5.26-4.479zM54.99 54.7L49.3 50.781l2.415-3.505.607.418-1.928 2.799 1.911 1.316 1.816-2.636.607.419-1.816 2.636 1.947 1.341 1.929-2.799.616.425L54.99 54.7zM53.455 44.871l.458-.852 6.265 1.33-.12.223-3.917-4.19.276-.513 5.607.952-.115.213-4.404-4.701.453-.843 4.93 5.42-.427.795-4.883-.813.078-.145 3.347 3.67-.427.795-7.121-1.34z","fill":"#fff"}})])
          )
        }
      }
    